import React from 'react';

const TroisPointsSvg = ({width = 20, height = 20}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40"
         fill="none">
        <circle cx="8.16667" cy="19.1654" r="4.16667"
                transform="rotate(-90 8.16667 19.1654)" fill="#002335"/>
        <circle cx="32.8337" cy="19.1654" r="4.16667"
                transform="rotate(-90 32.8337 19.1654)" fill="#002335"/>
        <circle cx="20.4997" cy="19.1654" r="4.16667"
                transform="rotate(-90 20.4997 19.1654)" fill="#002335"/>
    </svg>
);

export default TroisPointsSvg;
